import { Controller } from '@hotwired/stimulus'

// Mounts the real embed renderer in the builder from the schema printed on the page: no fetch,
// no token, submit disabled, so a deactivated form previews too and nothing is counted.
const WIDTHS = { desktop: '100%', tablet: '768px', mobile: '375px' }

export default class extends Controller {
  static targets = ['host', 'schema', 'frame', 'device']

  connect() {
    if (window.EightyEight) this.mount()
    else document.addEventListener('eightyeight:ready', () => this.mount(), { once: true })
  }

  mount() {
    if (this.hostTarget.dataset['88Mounted']) return
    const schema = JSON.parse(this.schemaTarget.textContent)
    window.EightyEight.mount(this.hostTarget, { schema, preview: true })
  }

  // The frame is also drag-resizable (CSS resize), so a pill sets the width rather than capping it.
  device(event) {
    this.frameTarget.style.width = WIDTHS[event.currentTarget.dataset.device] || '100%'
    this.deviceTargets.forEach((button) => {
      const active = button === event.currentTarget
      button.classList.toggle('active', active)
      button.setAttribute('aria-pressed', active)
    })
  }
}
